export default __webpack_public_path__ + "static/laptop-phone-6b98d1dbb1799cc76f3c39683f92bf31.png";